import "#legacy/shared/sparkle_namespace.js";
import "#legacy/utilities/ordered_ajax.js";
import "#legacy/admin/components/spotlight_search.js";

window.Sparkle ??= {};

function suggestAddressesUrl() {
  return window.Sparkle.apiHost
    ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.suggestAddresses
    : undefined;
}

Sparkle.AddressAutocomplete = class AddressAutocomplete extends Sparkle.SpotlightSearch {
  constructor(input, callback, options) {
    super(
      suggestAddressesUrl(),
      jQuery.extend(
        {
          input: jQuery(input),
          suggestionsContainerClass: "",
          suggestionClass: "",
          highlightMatchingPortions: false,
          status: false,
          details: false,
          position: false,
        },
        options,
      ),
    );
    this._fetch = this._fetch.bind(this);
    this._getSuggestions = this._getSuggestions.bind(this);
    this._processResults = this._processResults.bind(this);
    this._processResult = this._processResult.bind(this);
    this._initService = this._initService.bind(this);
    this.buildService = this.buildService.bind(this);
    if (options == null) {
      options = {};
    }

    this.input = this.options.input;

    this.suggestionsContainer = jQuery("<div>", { class: this.options.suggestionsContainerClass }).hide();

    // BEHAVIOUR

    this.input.on("focus", function () {
      return this.select();
    });
    this.input.on("spotlightSearch:select", (event, payload) => {
      if (callback) {
        return callback(payload);
      }
    });
  }

  // PRIVATE

  _fetch() {
    const query = this.input.val();
    return this._getSuggestions(query).then((results) => {
      results = this._processResults(results);
      return this._renderResults(results, query);
    });
  }

  _getSuggestions(...args) {
    return this._initService().then((service) => service.getSuggestions(...Array.from(args || [])));
  }

  _processResults(results) {
    return results.map(this._processResult);
  }

  _processResult(result) {
    result.address.stateCode = result.address.countrySubdivisionCode;
    return { name: result.address.freeformAddress, address: result.address };
  }

  _initService() {
    if (this.servicePromise != null) {
      return this.servicePromise;
    }

    this.servicePromise = new jQuery.Deferred().resolve(this.buildService()).promise();

    return this.servicePromise;
  }

  buildService() {
    const url = this.endpointUrl;

    return {
      getSuggestions(query) {
        return Sparkle.Utilities.OrderedAJAX.getJSON("AddressAutocomplete", url, { query });
      },
    };
  }
};
